import { renderComNegrito } from "_utils/Html";
import { Mensagem, Titulo } from "./style";

interface IProps {
  titulo: string;
  mensagem: string;
}

export function PopoverObservacao({ titulo, mensagem }: IProps) {
  return (
    <>
      <Titulo>{titulo}</Titulo>
      <Mensagem>{renderComNegrito(mensagem)}</Mensagem>
    </>
  );
}
